<template>
  <div class="tw-mt-2">
    <WdsText v-if="data.title && data.title !== sectionTitle" :text="data.title" sm class="tw-font-medium" />
    <ComplianceDataFieldRow
      v-for="(row, idx) in rows"
      :key="idx"
      :label="row.label"
      :value="row.value"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import ComplianceDataFieldRow from './ComplianceDataFieldRow.vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const ComplianceDataAddressFragment = graphql(`
  fragment ComplianceDataAddress on ComplianceDataAddress {
    title
    address {
      address
      postCode
      city
      state
      country {
        name
      }
    }
  }
`)

const props = defineProps<{ entry: FragmentType<typeof ComplianceDataAddressFragment>; sectionTitle?: string }>()
const data = computed(() => useFragment(ComplianceDataAddressFragment, props.entry))

const rows = computed(() => {
  const a = data.value.address
  return [
    { label: $t('Street'), value: a.address ?? null },
    { label: $t('Postcode'), value: a.postCode ?? null },
    { label: $t('City'), value: a.city ?? null },
    { label: $t('State'), value: a.state ?? null },
    { label: $t('Country'), value: a.country?.name ?? null },
  ]
})
</script>
